import type { CashTerminal, CashTypeFilter, CashViewMode } from './types'

const VIEW_KEY = 'kit.cash.view'

export function readCashViewMode(): CashViewMode {
  try {
    const v = localStorage.getItem(VIEW_KEY)
    if (v === 'list' || v === 'grid') return v
  } catch {
    /* ignore */
  }
  return 'list'
}

export function saveCashViewMode(mode: CashViewMode) {
  try {
    localStorage.setItem(VIEW_KEY, mode)
  } catch {
    /* ignore */
  }
}

export function isUkm5(type?: string) {
  return type === 'УКМ-5 (КСО)' || type === 'УКМ-5'
}

export function formatPing(raw?: string | number | null) {
  if (raw == null || raw === '' || raw === 'unknown') return '—'
  const s = String(raw).trim()
  if (!s) return '—'
  if (/ms/i.test(s)) return s
  if (/^\d+(\.\d+)?$/.test(s)) return `${s}ms`
  return s
}

function isFnProblematic(fnStatus?: string) {
  if (!fnStatus || fnStatus === '—') return false
  if (fnStatus.includes('Всё в порядке')) return false
  return true
}

export function isTerminalProblematic(t: CashTerminal) {
  if (t.archived) return false
  if (t.status !== 'online') return false
  if (t.kktFnPending) return false
  return isFnProblematic(t.fnStatus)
}

export function filterByType(rows: CashTerminal[], typeFilter: CashTypeFilter) {
  if (typeFilter === 'ukm4') return rows.filter((t) => !isUkm5(t.type))
  if (typeFilter === 'ukm5') return rows.filter((t) => isUkm5(t.type))
  return rows
}

export function sortTerminals(rows: CashTerminal[]) {
  return [...rows].sort((a, b) => {
    const aOff = a.status !== 'online' ? 0 : 1
    const bOff = b.status !== 'online' ? 0 : 1
    if (aOff !== bOff) return aOff - bOff
    const an = Number(a.num)
    const bn = Number(b.num)
    if (Number.isFinite(an) && Number.isFinite(bn)) return an - bn
    return String(a.num ?? '').localeCompare(String(b.num ?? ''), 'ru')
  })
}

export function terminalLabel(t: CashTerminal) {
  return t.num != null && t.num !== '' ? `№${t.num}` : `ID ${t.id}`
}
